<template>
  <div class="immersive-root">
    <main class="immersive-main">
      <slot />
    </main>
  </div>
</template>

<style scoped>
.immersive-root {
  display: flex;
  flex-direction: column;
  height: 100dvh;
  width: 100dvw;
  overflow: hidden;
  background: #000;
}

.immersive-main {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  /* 各ページが overlay ヘッダー等を絶対配置できるように */
  position: relative;
}
</style>
